import fflip from "fflip";

import criteria, { type CriteriaType } from "./criteria";

// Add and remove from this type as features are added/removed
// eg: type FeatureType = "a" | "b" | "c"
type FeatureType =
    | "modulePlaceholderFallback"
    | "throw500ForInvalidModules"
    | "hideInvalidModules"
    | "videoViewportAutoplay"
    | "enableSwagger"
    | "disableCacheTTL"
    | "useProductionNav"
    | "useLatestStories";

type Criteria = {
    [K in CriteriaType]?: boolean;
};

interface FeatureObject {
    id: FeatureType;
    criteria: Criteria | Criteria[];
}

const features: FeatureObject[] = [
    {
        id: "modulePlaceholderFallback",
        criteria: [
            { "env:nonProduction": true },
            { "env:blue": false },
            { "env:orange": false },
            { "env:preview": false },
        ],
    },
    {
        id: "throw500ForInvalidModules",
        criteria: {
            "env:none": true,
        },
    },
    {
        id: "hideInvalidModules",
        criteria: [
            { "env:production": true },
            { "env:blue": true },
            { "env:orange": true },
        ],
    },
    {
        id: "videoViewportAutoplay",
        criteria: {
            "env:nonProduction": true,
        },
    },
    {
        id: "enableSwagger",
        criteria: { "env:nonProduction": true },
    },
    {
        id: "disableCacheTTL",
        // logic OR when using a list
        criteria: [
            {
                "env:yellow": true,
            },
            {
                "env:purple": true,
            },
            {
                "env:green": true,
            },
            {
                "env:local": true,
            },
        ],
    },
    {
        id: "useProductionNav",
        criteria: [{ "env:production": true }, { "env:preview": true }],
    },
    {
        id: "useLatestStories",
        criteria: [
            { "env:nonProduction": true },
            { "env:production": true },
            { "env:orange": true },
            { "env:blue": true },
        ],
    },
];

fflip.config({
    criteria,
    features,
});

const isEnabled = (feature: FeatureType): boolean => {
    return fflip.isFeatureEnabledForUser(feature, {});
};

export default isEnabled;
